import * as ko from 'knockout'
import { Disposable } from '../../../../AppUtils/Framework/Disposable/Disposable'
import Guard from '../../../../AppUtils/Framework/Guard'
import type { BettingInformation } from '../../../Model/BettingInformation'
import type { IObservableStarter } from '../../../Model/Observables/IObservableStarter'
import type ObservableRaceKey from '../../../Model/Observables/ObservableRaceKey'
import { state$ as bettingV2CommandDriver$ } from '../../Commands/driver'

export class StartersListViewModelParams {
  raceStarters!: { Key: ObservableRaceKey; Value: ko.ObservableArray<IObservableStarter> }
  bettingContext!: BettingInformation
  hasFixedOdds!: ko.Observable<boolean>
  doubleProvDivAllowed!: ko.Observable<boolean>
  quaddieProvDivAllowed!: ko.Observable<boolean>
  isRaceClosed?: boolean
}

export class StartersListViewModel extends Disposable {
  public starters: ko.ObservableArray<IObservableStarter>
  public raceNumber: ObservableRaceKey
  public bettingContext: BettingInformation
  public isInfoVisible: ko.Observable<boolean>
  public numberOfStartersInRace: ko.PureComputed<number>
  private hasMarketMovers: ko.PureComputed<boolean>
  private hasFixedOdds: ko.PureComputed<boolean>
  private subInfoButton: Rx.Disposable
  public doubleProvDivAllowed: ko.Observable<boolean>
  public quaddieProvDivAllowed: ko.Observable<boolean>
  public isRaceClosed: ko.Observable<boolean> = ko.observable(false)

  constructor(params: StartersListViewModelParams) {
    super()

    Guard.notNull(params.raceStarters)
    Guard.notNull(params.bettingContext)

    this.bettingContext = params.bettingContext
    this.raceNumber = params.raceStarters.Key
    this.starters = params.raceStarters.Value

    this.hasMarketMovers = ko.pureComputed(() =>
      this.starters().some(starter => starter.hasMarketMovers())
    )

    this.numberOfStartersInRace = ko.pureComputed(() => this.starters().length)

    this.hasFixedOdds = ko.pureComputed(() =>
      this.starters().some(starter => starter.hasFixedOdds())
    )

    this.isInfoVisible = ko.observable(false)

    this.isRaceClosed(params.isRaceClosed || false)

    this.doubleProvDivAllowed = !this.isRaceClosed()
      ? params.doubleProvDivAllowed
      : ko.observable(false)
    this.quaddieProvDivAllowed = !this.isRaceClosed()
      ? params.quaddieProvDivAllowed
      : ko.observable(false)

    this.subInfoButton = bettingV2CommandDriver$
      .map(record => {
        return {
          showAllForm: record.showAllForm,
          showFixedFlucs: record.showFixedFlucs,
          showMarketMovers: record.showMarketMovers,
          showDoubleProvDiv: record.showDoubleProvDiv,
          showQuaddieProvDiv: record.showQuaddieProvDiv,
        }
      })
      .distinctUntilChanged()
      .subscribe(record => {
        //  This is where the subscription to the driver state is resolved. Put logic here, not in toggleFixedFlucs.
        if (!this.isRaceClosed()) {
          this.isInfoVisible(
            record.showAllForm ||
              (record.showFixedFlucs && this.hasFixedOdds()) ||
              (record.showMarketMovers && this.hasMarketMovers()) ||
              (record.showDoubleProvDiv && this.doubleProvDivAllowed()) ||
              (record.showQuaddieProvDiv && this.quaddieProvDivAllowed())
          )
        }
      })

    this.registerDisposals(() => {
      this.subInfoButton.dispose()
    })
  }
}
